export default __webpack_public_path__ + "static/media/AWS.0e192486.png";